import { ID, overdueSectionID } from '@griply/types';

import { parseDateKey } from '../format-date-key';

export type UpcomingSectionPrefixes = {
  restOfMonth: string;
  month: string;
  year: string;
};

export const getUpcomingSectionDate = (
  sectionId: ID,
  prefixes: UpcomingSectionPrefixes,
): Date | undefined => {
  if (sectionId === overdueSectionID) {
    return undefined;
  }

  if (sectionId.startsWith(prefixes.restOfMonth)) {
    return parseDateKey(sectionId.slice(prefixes.restOfMonth.length));
  }

  if (sectionId.startsWith(prefixes.month)) {
    return parseDateKey(sectionId.slice(prefixes.month.length));
  }

  if (sectionId.startsWith(prefixes.year)) {
    return parseDateKey(sectionId.slice(prefixes.year.length));
  }

  return parseDateKey(sectionId);
};
